module.exports = __webpack_public_path__ + "static/media/failIcon.71513020.svg";